import React from 'react';
import { LandingThemeProvider } from '../contexts/LandingThemeContext';
import { TranslationProvider } from '../contexts/TranslationContext';

const LandingPageWrapper = ({ children }) => {
  return (
    <LandingThemeProvider>
      <TranslationProvider>
        <div className="min-h-screen bg-background text-foreground">
          {children}
        </div>
      </TranslationProvider>
    </LandingThemeProvider>
  );
};

export default LandingPageWrapper;
